export var formatTelNo = function formatTelNo(tel) {
  return tel.replace(/\s/g, '');
};